import React, { useEffect, useState } from "react";
import MapPicker from "../../CoreComponents/MapPicker";
import { googleApiKey } from "../../Functionalities/Config";
import { ManageSettingsAdmin } from "../Franchise/Logic";
import Map from "./Map";

const MapView = (props) => {
  const DefaultLocation = {
    lat: props.latitude,
    lng: props.longitude,
  };

  const cirle = {
    radius: 3000,
    options: {
      strokeColor: "cornflowerblue",
    },
  };

  const DefaultZoom = 12;

  const [defaultLocation, setDefaultLocation] = useState(DefaultLocation);

  const [location, setLocation] = useState(
    props.coordinates ? props.coordinates : DefaultLocation
  );
  const [zoom, setZoom] = useState(DefaultZoom);
  const [apiKey, setapiKey] = useState("");
  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    let res = ManageSettingsAdmin(
      "",
      "",
      "get",
      "param_name=googlemap_key&keyword=super_admin_conf"
    );
    res.then((result) => {
      if (result?.data?.Message?.param_value && result.data.Message.param_value !== "XXXXXXXXXXXXXX") {
        setapiKey(result.data.Message.param_value);
      } else {
      }
      // void 0
    });
  };
  function handleChangeLocation(lat, lng) {
    setLocation({ lat: lat, lng: lng });
    props.onChange(lat, lng);
  }

  function handleChangeZoom(newZoom) {
    setZoom(newZoom);
  }

  return (
    <div>
      {apiKey !== "" && (
        <MapPicker
          defaultLocation={location}
          zoom={zoom}
          style={{ height: "400px", marginTop: 20 }}
          onChangeLocation={handleChangeLocation}
          onChangeZoom={handleChangeZoom}
          // apiKey={googleApiKey}
          apiKey={apiKey}
        />
      )}
    </div>
  );
};

export default MapView;
